import React from 'react'
import Fragment from '../common/fragment'


function FragmentBK(props) {
  return (
    <Fragment pos="kk" {...props}>
      <img
        src="https://volverse-negro-daniel.s3.amazonaws.com/images/image5.jpg"
        alt="Señora de la abejas"
      />
    </Fragment>
  )
}


export default FragmentBK
